import { Tag, Dropdown, Button } from "antd";
import {
  EyeOutlined,
  ReloadOutlined,
  StarOutlined,
  StopOutlined,
  RightOutlined,
  SafetyOutlined,
} from "@ant-design/icons";
import { PLAN_NAME, toTitleCase } from "../../utils";

const getRoleTag = (role) => {
  const isAdmin = role === "admin";
  return (
    <Tag className={isAdmin ? "role-admin" : "role-user"}>
      {role === "admin" ? "Admin" : "User" }
    </Tag>
  );
};

const getActionMenu = (record = {}, handleActionClick) => {
  const isDisabled =
    record.status === "suspended" || record.status === "deleted";

  return {
    onClick: (e) => handleActionClick(e.key, record),
    items: [
      {
        key: "view",
        icon: <EyeOutlined />,
        label: "View User",
      },
      {
        key: "reset",
        icon: <ReloadOutlined />,
        label: "Reset Scan Counter",
        disabled: true,
      },
      {
        key: "grant",
        icon: <StarOutlined />,
        label: "Grant Premium Access",
        disabled: true,
      },
      {
        key: isDisabled ? "restore" : "suspend",
          icon: (
            isDisabled ? <SafetyOutlined style={{color: 'green'}} /> :<StopOutlined style={{ color: "red" }} />
        ),
        label: (
          <span style={{ color: isDisabled ? "green" : "red" }}>
            {isDisabled ? "Restore User" : "Disable User"}
          </span>
        ),
        disabled: record.roleName === "admin" && !isDisabled
      },
    ],
  };
};


export const usersColumns = (handleActionClick) => [
  {
    title: "User ID",
    dataIndex: "_id",
    width: 90,
    render: (_data, _record, index) => `#${index + 1}`,
  },
  {
    title: "Name",
    dataIndex: "fullName",
    width: 130,
  },
  {
    title: "Email",
    dataIndex: "email",
    width: 210,
  },
  {
    title: "Role",
    dataIndex: "roleName",
    width: 90,
    render: getRoleTag,
  },
  // {
  //   title: "Country",
  //   dataIndex: "country",
  //   width: 130,
  // },
  {
    title: "Tier",
    dataIndex: "planName",
    width: 90,
    render: (v) => PLAN_NAME[v] || "–",
  },
  {
    title: "Subscription Status",
    dataIndex: "subscriptionStatus",
    width: 160,
    render: (v) => toTitleCase(v ?? "–"),
  },
  // {
  //   title: "Plan Type",
  //   dataIndex: "planType",
  //   width: 120,
  //   render: (v) => v ?? "–",
  // },
  // {
  //   title: "Renewal Date",
  //   dataIndex: "renewalDate",
  //   width: 120,
  //   render: (v) => v ?? "–",
  // },
  {
    title: "Scans Used",
    dataIndex: "scansUsed",
    width: 100,
    render: (v) => v ?? "–",
  },
  {
    title: "Last Active",
    dataIndex: "lastActive",
    width: 110,
    render: (v) => v ?? "–",
  },
  {
    title: "Created",
    dataIndex: "createdAt",
    width: 110,
    render: (v) => v ? new Date(v).toLocaleDateString() : "–",
  },
  {
    title: "Account Status",
    dataIndex: "status",
    width: 130,
    render: (v) => toTitleCase(v ?? "–"),
  },
  {
    title: "Action",
    key: "action",
    width: 120,
    fixed: "right",
    render: (_, record) => (
    <Dropdown menu={getActionMenu(record, handleActionClick)} trigger={["click"]}>
      <Button className="action-btn">
        Actions <RightOutlined />
      </Button>
    </Dropdown>
  ),
  },
];